import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DocumentService } from '../../shared/web-api/document.service';
import { PageService } from '../../shared/web-api/page.service';
//import { TreeModule, TreeComponent, TreeNode, TreeModel } from 'angular2-tree-component';
import { DropdownModule } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { DialogModule } from 'primeng/primeng';
import { TabViewModule } from 'primeng/primeng';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { BreadcrumbModule } from '../../shared/custom/breadcrumb/breadcrumb.module';
import { BreadcrumbComponent, Breadcrumb, TreeBreadcrumb } from '../../shared/custom/breadcrumb/breadcrumb.component';
import { LanguageService } from "../../shell/language/language.service";

@Component({
    selector: 'app-page-view',
    templateUrl: './page-view.component.html',
    styleUrls: ['./page-view.component.scss']
})
export class PageViewComponent implements OnInit {

    pageId: number;
    slug: string;
    languageId: number;
    page: app.models.PageResult;
    treeBreadcrumbNodes: TreeBreadcrumb[];
    rowLevel: number = 0;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private pageService: PageService,
        private languageService: LanguageService
    ) {
    }

    loadPage() {
        var model: app.models.PageSearch =
        {
            pageId: this.pageId,
            languageId: this.languageId,
            slug: this.slug
        };
        console.log(model);

        this.pageService.getPage(model)
            .subscribe(result => {
                //console.log(result);
                this.page = result.data;
                this.pageId = result.data.pageId;
            });
    }

    loadPageFromLanguageChange(languageChanged, oldLanguage) {
        console.log(window.location.pathname);
        if (!window.location.pathname.startsWith('/page'))
            return;
        var model: app.models.PageSearch =
        {
            pageId: this.pageId,
            languageId: this.languageId,
            slug: this.slug
        };
        //if (this.pageId > 0 && this.languageId > 0 && languageChanged) {
        //    model.slug = "";
        //    this.pageService.getSlugForLanguage(model)
        //        .subscribe(s => {
        //            this.router.navigateByUrl('/pages/' + s.data);
        //        });
        //} else {
        //    console.log(model);

        //    this.pageService.getPage(model)
        //        .subscribe(result => {
        //            //console.log(result);
        //            this.page = result.data;
        //            this.pageId = result.data.pageId;
        //        });
        //}

        if (this.pageId > 0 && this.languageId > 0 && languageChanged) {
            model.slug = "";

        }
        console.log(model);

        this.pageService.getPage(model)
            .subscribe(result => {
                //console.log(result);
                this.page = result.data;
                this.pageId = result.data.pageId;

                this.treeBreadcrumbNodes = [];
                if (this.page)
                    this.treeBreadcrumbNodes.push({ label: this.page.title, url: `/pages/${this.pageId}`, id: undefined, params: {}, routePattern: undefined })
            });

    }

    ngOnInit() {
        //alert('dsdsds');
        this.route.params.forEach((params: Params) => {
            let id = +params['id']; // (+) converts string 'id' to a number
            let slug = params['slug']; // (+) converts string 'id' to a number
            this.slug = slug;

            // alert(id);
            this.pageId = id;
            if (!this.pageId)
                this.pageId = 0;
            this.loadPage();
            this.languageService.selectedLangauge.subscribe(selectedLanguage => {
                //console.log("selected language in pages" + selectedLanguage.isoCode);
                //console.log(selectedLanguage);
                let oldLanguage = this.languageId;
                let languageChanged = this.languageId !== selectedLanguage.languageId;
                this.languageId = selectedLanguage.languageId;
                this.loadPageFromLanguageChange(languageChanged, oldLanguage);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/page-view/page-view.component.ts